import { CreateGenerateClassNameOptions } from 'react-jss';

// SLT-3336 Для того, чтобы затипизировать нужно описать много интерфейсов сейчас нам не нужных, поэтому any
export function createGenerateClassName(
    options: CreateGenerateClassNameOptions
): (rule: any, sheet: any) => string {
    let ruleCounter = 0;

    return (rule: any, sheet: any) => {
        ruleCounter += 1;

        const name = isProd
            ? `${options.productionPrefix}-${ruleCounter}-${isSSR ? 'ssr' : 'csr'}`
            : `${sheet.options.classNamePrefix}${rule.key}-${options.seed}-${ruleCounter}-${isSSR ? 'ssr' : 'csr'}`;

        return name;
    };
}
